import { MIN_INSIGHT_POSTS } from './insightThresholds';

export type FormatInsight = { media_type: string; posts: number; median_views?: number | null };
export type RankedFormat = FormatInsight & { sufficient: boolean };

const medianOf = (format: FormatInsight) => (
  typeof format.median_views === 'number' && Number.isFinite(format.median_views) ? format.median_views : null
);

/** Ranked formats first (best median, then more posts); formats with too few posts last, flagged, same order. */
export function rankFormats(formats: readonly FormatInsight[]): RankedFormat[] {
  return formats
    .map((format) => ({ ...format, sufficient: format.posts >= MIN_INSIGHT_POSTS && medianOf(format) !== null }))
    .sort((a, b) => (
      Number(b.sufficient) - Number(a.sufficient)
      || (medianOf(b) ?? -1) - (medianOf(a) ?? -1)
      || b.posts - a.posts
    ));
}
